import classnames from 'classnames';
import React, { FC } from 'react';

import './AlertAnimation.scss';

export interface AlertAnimationProps {
    className?: string;
    mini?: boolean;
}

const AlertAnimation: FC<AlertAnimationProps> = ({ className, mini }) => {
    return (
        <div className={classnames('sgw-alert-animation', className, { 'alert-mini': mini })} aria-hidden>
            <svg viewBox="0 0 500 500">
                <line className="line" x1="249.6" y1="135.4" x2="249.6" y2="280.9" />
                <circle className="dot" cx="249.6" cy="368" r="8.3" />
                <circle className="circle" cx="249.6" cy="250.4" r="231.6" />
            </svg>
        </div>
    );
};

export default AlertAnimation;
